import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { storeSet } from '../../store';

// helpers
import displayNetworkError from '../../helpers/displayNetworkError';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';

// styles
import '../../assets/components/ModalUploadTrack.css';

const ModalUploadTrack = ({
    projectId,
    recSessionId,
    type,
    sessionType,
    targetLayerId = null,
    onClose
}) => {
    const [loading, setLoading] = useState(false);
    const isCore = type === 'CORE';

    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            label: '',
            title: '',
            file: null
        }
    });

    const header = isCore
        ? __('Carica traccia principale', 'soundbetween')
        : <>
            {__('Carica sessione remota', 'soundbetween')}
            <span className="modalUploadTrack__subtitle">{__('Carica la tua traccia', 'soundbetween')}</span>
        </>;

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            await storeSet('uploadRecSessionTrack', projectId, recSessionId, formData, type, sessionType, { targetLayerId });
            reset();
            onClose();
        } catch (error) {
            displayNetworkError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        reset();
        onClose();
    };

    return (
        <ModalDialog
            additionalClasses={['modalUploadTrack']}
            header={header}
            visible={true}
            onSubmit={handleSubmit(onSubmit)}
            onHide={handleCloseModal}
        >
            <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                {!isCore && (
                    <FormField
                        type="text"
                        name="label"
                        label={__('Label', 'soundbetween')}
                        placeholder={__('es 1m3', 'soundbetween')}
                        control={control}
                        rules={{
                            required: __('È obbligatorio', 'soundbetween')
                        }}
                    />
                )}

                <FormField
                    type="text"
                    name="title"
                    label={__('Titolo', 'soundbetween')}
                    placeholder={__('Inserisci titolo', 'soundbetween')}
                    control={control}
                    rules={{
                        required: __('È obbligatorio', 'soundbetween')
                    }}
                />

                <FormField
                    control={control}
                    name="file"
                    label={__('Carica file', 'soundbetween')}
                    placeholder={__('Scegli un file', 'soundbetween')}
                    type="fileupload"
                    accept=".mp3"
                    rules={{
                        required: __('È obbligatorio', 'soundbetween')
                    }}
                />

                <div className="appFormActions">
                    <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                        {__('Annulla', 'soundbetween')}
                    </ButtonFlat>
                    <ButtonFormSubmit disabled={loading || !isValid}>
                        {__('Salva', 'soundbetween')}
                    </ButtonFormSubmit>
                </div>
            </form>
        </ModalDialog>
    );
};

export default ModalUploadTrack;
